import React from 'react';
import classNames from 'classnames';
import { Button, NamedLink } from '../../../../components';
import { FormattedMessage } from '../../../../util/reactIntl';
import config from '../../../../config';
import { getCurrentUserLocation } from '../../../../util/localStorage';
import css from './SectionNewListingsNearby.css';
import SectionListings from '../SectionListings/SectionListings';
import routeConfiguration from '../../../../routeConfiguration';
import { createResourceLocatorString } from '../../../../util/routes';
import { somePeriodAgo } from '../../../../util/dates';

const {
    listingTypeHorse,
    initialSearchAddress,
    defaultCountry,
    maps: { supportedCountries },
} = config;

export default ({ history, isMobile, listingType = listingTypeHorse, ...rest }) => {
    const { country, countrySelected } = getCurrentUserLocation();
    const {
        code,
        defaultAddress: { origin },
    } =
        supportedCountries[countrySelected] ||
        supportedCountries[country] ||
        supportedCountries[defaultCountry];

    const { address: initialAddress, bounds: initialBounds } = initialSearchAddress[code];

    const pageName = listingType === listingTypeHorse ? 'SignupRider' : 'SignupHorseowner';

    const params = {
        pub_type: listingType,
        per_page: 100,
        origin: null,
        sort: 'createdAt',
    };

    const filterByNewDate = listing => {
        const { createdAt } = listing.attributes || {};
        const past = somePeriodAgo(config.newListingNumberOfDays, 'day');
        const isNewListing = createdAt && past < createdAt;
        return isNewListing;
    };

    return (
        <SectionListings
            params={params}
            filterer={filterByNewDate}
            headingId={`SectionNewListingsNearby.heading-${listingType}`}
            descriptionId={`SectionNewListingsNearby.description-${listingType}`}
            descriptionValues={{
                actionLink: (
                    <NamedLink name={pageName}>
                        <FormattedMessage id="SectionNewListingsNearby.action-link" />
                    </NamedLink>
                ),
            }}
            {...rest}
        >
            <footer className={classNames(css.footer, css.linksHolder)}>
                <Button
                    className={css.subLinkOutlined}
                    type="button"
                    onClick={() =>
                        history.push(
                            createResourceLocatorString(
                                'SearchPage',
                                routeConfiguration(),
                                {},
                                {},
                                `?address=${initialAddress}&bounds=${initialBounds}&origin=${origin}&listingType=${listingType}`
                            )
                        )
                    }
                >
                    <FormattedMessage
                        id={`SectionNewListingsNearby.action-primary-${listingType}`}
                    />
                </Button>
            </footer>
        </SectionListings>
    );
};
